export default __webpack_public_path__ + "static/media/announcement-highlight-summary-inner.a23ec9dc.svg";